import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F8F8] px-6" style={{ fontFamily: "Manrope, sans-serif" }}>
      <div className="max-w-md text-center" data-testid="not-found-page">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#0A8B85]/10">
          <Compass className="h-7 w-7 text-[#0A8B85]" />
        </div>
        <h1 className="mt-5 text-3xl font-bold text-neutral-900">Page not found</h1>
        <p className="mt-2 text-sm text-neutral-600">
          That link doesn&apos;t exist (or has moved). Let&apos;s get you back on track.
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" data-testid="not-found-home" className="rounded-lg bg-[#0A8B85] px-5 py-2.5 text-sm font-bold text-white hover:bg-[#066667]">Go home</Link>
          <Link to="/login" data-testid="not-found-login" className="rounded-lg border border-neutral-300 bg-white px-5 py-2.5 text-sm font-bold text-neutral-800 hover:border-[#0A8B85]">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
